import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { FormDataService } from '../data.service';
import { FormShareService } from '../share.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { SignaturesSendService } from '../../../management/signatures/send/send.service';
import { SaveCreditsFormActionHandlerService } from './save-credits.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { Audit } from '../../../entertainment/models/film/audit.model';
import { EmailService } from '../../../email/services/email.service';
import { PublishSubscribeService } from '../../../fastlane-common/services/publish-subscribe.service';
import { AttachmentsService } from '../../../project/services/attachments.service';
import {NavService} from '../../../fastlane-common/services/nav.service';

@Injectable()
export class CreateFinalCertLetterService extends SaveCreditsFormActionHandlerService {
  constructor(
    public attachmentService: AttachmentsService,
    formDataService: FormDataService,
    formShareService: FormShareService,
    formStatusService: FormStatusService,
    swalService: SwalService,
    userContextService: UserContextService,
    private esignService: SignaturesSendService,
    emailService: EmailService,
    pubSubService: PublishSubscribeService,
    public navService: NavService
  ) {
    super(
      attachmentService,
      formDataService,
      formShareService,
      formStatusService,
      swalService,
      userContextService,
      emailService,
      pubSubService,
      navService
    );
  }

  exec(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      super
        .exec()
        .then(() => {
          that.esignService
            .sendAgreement(this.formShareService.formId)
            .subscribe(projectAgreementId => {
              (<Audit>that.formShareService.form).isFinalCertSent = true;
              that.formShareService.form.projectAgreementId = projectAgreementId;
              super
                .exec()
                .then(() => {
                  that.swalService.success({
                    title:
                      'Final Certification Letter has been sent for Signature successfully!!'
                  });
                })
                .catch(() => {});
            });
        })
        .catch(() => {});
    });
  }
}
